import { required, numeric } from "vuelidate/lib/validators";
import date from "@/validation/date";

export default {
  organization: {
    name: { required },
    description: { required },
    amount: { required },
    date: { required, date }
  }
};
